<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Envio de documentos</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Assunto e mensagem padrão do e-mail e envio por WhatsApp
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="section-container">
        <app-loading-box height="30" width="200" marginTop="0"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
        <app-loading-box height="120" width="100%" marginTop="16"></app-loading-box>
      </div>
      <div class="section-container">
        <app-loading-box height="30" width="200" marginTop="0"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
        <app-loading-box height="120" width="100%" marginTop="16"></app-loading-box>
      </div>
    } @else {
      <form [formGroup]="form">

        <!-- ── NFSE ─────────────────────────────────────────── -->
        <div class="section-container">
          <div class="section-title">
            <mat-icon>receipt_long</mat-icon>
            <span>NFSe</span>
          </div>

          <div class="row">
            <div class="col-12 mt-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Assunto padrão para envio da NFSe</mat-label>
                <input
                  matInput
                  #nfseAssuntoInput
                  formControlName="nfseAssunto"
                  id="nfseAssunto"
                  [maxlength]="tamanhoMaximoAssunto"
                  (focus)="isNfseAssuntoFocado = true" />
                @if (form.controls.nfseAssunto.hasError('maxlength')) {
                  <mat-error>O assunto deve ter no máximo {{ tamanhoMaximoAssunto }} caracteres.</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-12">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Mensagem padrão para envio da NFSe</mat-label>
                <textarea
                  matInput
                  #nfseMensagemInput
                  formControlName="nfseMensagem"
                  id="nfseMensagem"
                  rows="5"
                  (focus)="isNfseAssuntoFocado = false"></textarea>
              </mat-form-field>
            </div>

            <div class="col-12">
              <a class="variaveis-link" (click)="toggleVariaveisNfse()" id="toggle-variaveis-nfse">
                <mat-icon class="variaveis-icon">swap_horiz</mat-icon>
                {{ showVariaveisNfse ? 'Ocultar variáveis disponíveis' : 'Exibir variáveis disponíveis' }}
              </a>
              @if (showVariaveisNfse) {
                <app-alert-card type="info">
                  <strong>Variáveis disponíveis para uso no assunto e na mensagem:</strong>
                  <ul class="list-unstyled d-flex flex-column gap-2 mt-2 mb-0">
                    @for (variavel of variaveis; track variavel.codigo) {
                      <li class="d-flex align-items-center flex-wrap gap-2">
                        <button
                          mat-button
                          type="button"
                          class="variavel-button"
                          (click)="inserirVariavelNfse(variavel.codigo)">
                          <code>{{ variavel.codigo }}</code>
                        </button>
                        <span>{{ variavel.descricao }}</span>
                      </li>
                    }
                  </ul>
                </app-alert-card>
              }
            </div>
          </div>
        </div>

        <!-- ── ORDEM DE SERVIÇO ─────────────────────────────── -->
        <div class="section-container">
          <div class="section-title">
            <mat-icon>build</mat-icon>
            <span>Ordens de serviço</span>
          </div>

          <div class="row">
            <div class="col-12 mt-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Assunto padrão para envio da ordem de serviço</mat-label>
                <input
                  matInput
                  #ordemServicoAssuntoInput
                  formControlName="ordemServicoAssunto"
                  id="ordemServicoAssunto"
                  [maxlength]="tamanhoMaximoAssunto"
                  (focus)="isOrdemServicoAssuntoFocado = true" />
                @if (form.controls.ordemServicoAssunto.hasError('maxlength')) {
                  <mat-error>O assunto deve ter no máximo {{ tamanhoMaximoAssunto }} caracteres.</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-12">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Mensagem padrão para envio da ordem de serviço</mat-label>
                <textarea
                  matInput
                  #ordemServicoMensagemInput
                  formControlName="ordemServicoMensagem"
                  id="ordemServicoMensagem"
                  rows="5"
                  (focus)="isOrdemServicoAssuntoFocado = false"></textarea>
              </mat-form-field>
            </div>

            <div class="col-12">
              <a class="variaveis-link" (click)="toggleVariaveisOrdemServico()" id="toggle-variaveis-ordem-servico">
                <mat-icon class="variaveis-icon">swap_horiz</mat-icon>
                {{ showVariaveisOrdemServico ? 'Ocultar variáveis disponíveis' : 'Exibir variáveis disponíveis' }}
              </a>
              @if (showVariaveisOrdemServico) {
                <app-alert-card type="info">
                  <strong>Variáveis disponíveis para uso no assunto e na mensagem:</strong>
                  <ul class="list-unstyled d-flex flex-column gap-2 mt-2 mb-0">
                    @for (variavel of variaveis; track variavel.codigo) {
                      <li class="d-flex align-items-center flex-wrap gap-2">
                        <button
                          mat-button
                          type="button"
                          class="variavel-button"
                          (click)="inserirVariavelOrdemServico(variavel.codigo)">
                          <code>{{ variavel.codigo }}</code>
                        </button>
                        <span>{{ variavel.descricao }}</span>
                      </li>
                    }
                  </ul>
                </app-alert-card>
              }
            </div>
          </div>
        </div>

        <!-- ── WHATSAPP ─────────────────────────────────────── -->
        <div class="section-container">
          <div class="section-title">
            <mat-icon>chat</mat-icon>
            <span>WhatsApp</span>
          </div>

          <div class="row">
            <div class="col-12 mt-3">
              <mat-slide-toggle formControlName="isEnvioWhatsapp" id="isEnvioWhatsapp">
                Habilitar envio por WhatsApp
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isSaving"
  [isSalvarDisabled]="!configCarregada || isLoading"
  (cancelar)="voltar()"
  (salvar)="salvar()">
</app-footer-action>
